module.exports = __webpack_public_path__ + "images/VivaEngageHeroBannerDark-f9323826f52970c0ad6f07c5630dfe0a.png";